import gql from 'graphql-tag'

export default gql`
  mutation updateDuwa($payload: DuwaUpdateInput!) {
    updateDuwa(payload: $payload) {
      uuid
    }
  }
`
